import {useState, useEffect} from "react";
import amahle from "./amahle.png"
import "./Navbar.css";
import { Link } from "react-router-dom";

const Navbar = ({ redirectToTop }) => {
  const[isOpen, setIsOpen] = useState(false);

  function showMenu() {
    setIsOpen(true);
  }
  function hideMenu() {
    setIsOpen(false);
  }

  useEffect(()=>{
    const overlay = document.getElementById("over");
    const body = document.querySelector("body");

    if(isOpen === true){
      overlay.classList.add("overlay");
      body.classList.add("stop");
    } else{
      overlay.classList.remove("overlay");
      body.classList.remove("stop");
    }
  });

  const CloseMenu = () =>{
    setIsOpen(false);
  }

    return ( 
        <>
            <div id="over" onClick={() => { CloseMenu()}}></div>
            <nav>
              <Link to="/"  onClick={()=>{redirectToTop(); setIsOpen(false)}}><img src={amahle} alt="" /></Link>
  
              <div className="nav-links" id="navLinks" style={{right: isOpen? "0" : "-200px"}}>
                <i className="fa fa-times" onClick={() => hideMenu()}></i>
                <ul>
                  <li><Link to="/" onClick={()=>{redirectToTop(); setIsOpen(false)}}>HOME </Link></li>
                  <li><Link to="/about" onClick={()=>{redirectToTop(); setIsOpen(false)}}> ABOUT US </Link></li>
                  <li><Link to="/service" onClick={()=>{redirectToTop(); setIsOpen(false)}}>SERVICES</Link></li>
                  <li><Link to="/contact" onClick={()=>{redirectToTop(); setIsOpen(false)}}>CONTACT</Link></li>
                </ul>
              </div>
  
              <a href="https://sacoronavirus.co.za/" className="btn covid">COVID-19</a>
              <i className="fa fa-bars" onClick={() => showMenu()}></i>
        </nav>
      </>
     );
}
 
export default Navbar;